import ISubCategory from "../../categories/ISubCategory";
import IMenuItemBody from "../../../../interfaces/IMenuItemBody";
import { IProduct } from "../../../../interfaces/IProduct";
import { IMenuData } from "../../../manageMenu/types";


export const SET_CATEGORY_ID = "SET_CATEGORY_ID";

export function setCategoryId(categoryId: string) {
    return {
        type: SET_CATEGORY_ID,
        payload: categoryId
    };
}

export const SET_SUBCATEGORY_ID = "SET_SUBCATEGORY_ID";

export function setSubcategoryId(subcatId: string) {
    return {
        type: SET_SUBCATEGORY_ID,
        payload: subcatId
    };
}

export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";

export function setProductList(productList: IProduct[]) {
    return {
        type: SET_PRODUCT_LIST,
        payload: productList
    };
}

export const SET_SELECTED_PRODUCT_LIST = "SET_SELECTED_PRODUCT_LIST";

export function setSelectedProductList(productList: IMenuItemBody[]) {
    return {
        type: SET_SELECTED_PRODUCT_LIST,
        payload: productList
    };
}

export const SET_SELECTED_SUBCATS = "SET_SELECTED_SUBCATS";

export function setSelectedSubcategories(subcategories: ISubCategory[]) {
    return {
        type: SET_SELECTED_SUBCATS,
        payload: subcategories
    };
}
export const SET_FILTER_STATE = "SET_FILTER_STATE";

export function setFilterState(filterState: any) {
    return {
        type: SET_FILTER_STATE,
        payload: filterState
    };
}

export const SET_ITEMS_NOT_IN_MENU = "SET_ITEMS_NOT_IN_MENU";

export function setItemsNotInMenu(items:IMenuItemBody[]) {
    return {
        type: SET_ITEMS_NOT_IN_MENU,
        payload: items
    };
}


export const SET_MENUS_LIST = "SET_MENUS_LIST";

export function setMenusList(menus:IMenuData[]) {
    return {
        type: SET_MENUS_LIST,
        payload: menus
    };
}

